import React from 'react';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';
import Nav from '../Navigation/Nav';

const styles = css`
  display: none;
  @media (min-width: 992px) {
    display: block;
    position: relative;
    z-index: 1;
  }
  .DesktopNav_nav {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .DesktopNav_navItem {
    list-style: none;
    border-bottom: 1px solid ${colors.neutral};
    @media (min-width: 992px) {
      display: flex;
      position: relative;
      border: 0;
    }
  }
  .DesktopNav_navHeading {
    height: 60px;
    padding: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 17px;
    letter-spacing: 1px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${colors.white};
    cursor: pointer;
    transition: all .3s ease;
    font-family: ${typography.Condensed};
    &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand2Light};
      position: relative;
      margin: 0 0 0 5px;
    }
    &:hover {
      outline: none;
      border: none;
    }
    &-link {
      &::after {
        display: none;
      }
    }
  }
  .DesktopNav_menu {
    display: none;
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    position: relative;
    @media (min-width: 992px) {
      position: absolute;
      top: 60px;
      left: 0;
      width: auto;
      background-color: ${colors.white};
      color: ${colors.white};
      padding: 0 5px 5px 5px;
      font-size: 15px;
    }
  }
  .DesktopNav_navItem:last-child .DesktopNav_menu {
    @media (min-width: 992px) {
      left: auto;
      right: 0;
    }
  }
  .DesktopNav_menu-active {
    display: block;
  }
  .DesktopNav_menuItem a {
    color: ${colors.brand1Dark};
    padding: 12px 15px;
    display: block;
    transition: all .3s ease;
    background-color: ${colors.white};
    font-weight: 700;
    white-space: nowrap;
    &:hover {
      background-color: ${colors.neutral};
      color: ${colors.brand3};
    }
  }
`;

function DesktopNav() {
  return (
    <div className={styles}>
      <Nav
        id="header"
        className="DesktopNav_nav"
        toggleSubMenus
        menuProps={{
          className: 'DesktopNav_navItem',
          subMenuClassName: 'DesktopNav_menu',
          subMenuActiveClassName: 'DesktopNav_menu-active',
          headingClassName: 'DesktopNav_navHeading',
          itemClassName: 'DesktopNav_menuItem',
        }}
      />
    </div>
  );
}

export default DesktopNav;



// WEBPACK FOOTER //
// ./src/components/Header/DesktopNav.js